import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Checkbox,
} from "@mui/material";
import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, uniqBy } from "lodash";
import { Tabs } from "../../components/tabs";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";
import { SelectA } from "../../components/form";
import {MyLeaves} from "./myleaves";
import { SwapRequests } from "./swapRequests";

const { uniq } = require("lodash");

const API_HOST = CONFIG.modules["accounts"].host;

const items = {
	'My Leaves': {
		name: "My Leaves",
		view: () => <MyLeaves/>,
	},
	'Swap Requests': {
		name: "Swap Requests",
		view: () => <SwapRequests/>,
	},
   

};

export const ApplyLeave = (props) => {
	const {
		roles,
		user,
		users,
		Designations,
		Departments,
		Languages,
		Districts,
		TaskTypes,
		Campaigns,
	} = useSelector((state) => state.user || {});
	const [active, setActive] = useState("My Leaves");

	return (
		<>
			<Tabs
				items={items}
				active={active}
				onChange={(key) => {
					setActive(key);
				}}
			/>

			{items[active] && items[active].view && items[active].view()}
		</>
	);
};
